// src/components/SignInModal.js
import React, { useState } from "react";
import { X } from "lucide-react";

const SignInModal = ({ onClose, onSwitch }) => {
  const [error, setError] = useState("");

  const handleSignIn = (e) => {
    e.preventDefault();
    const email = e.target.email.value.trim();
    const password = e.target.password.value.trim();

    if (!email || !password) {
      setError("Please enter both email and password.");
      return;
    }

    setError("");
    alert("Signed in successfully!");
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]">
      <div className="bg-white w-96 p-6 rounded-lg shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600"
        >
          <X size={20} />
        </button>
        <h2 className="text-2xl font-bold text-center mb-4">
          Sign In to SmokyShop
        </h2>
        <form className="space-y-4" onSubmit={handleSignIn}>
          <input
            name="email"
            type="email"
            placeholder="Email"
            className="w-full border p-2 rounded-md"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            className="w-full border p-2 rounded-md"
          />
          {error && <p className="text-red-500 text-center text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full bg-amber-500 hover:bg-amber-600 text-white py-2 rounded-md"
          >
            Sign In
          </button>
        </form>
        <p className="text-center text-sm mt-3">
          New here?{" "}
          <button
            onClick={() => onSwitch("create")}
            className="text-amber-600 font-semibold"
          >
            Create Account
          </button>
        </p>
      </div>
    </div>
  );
};

export default SignInModal;
